import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import EnterpriseApiDocs from "@/pages/EnterpriseApiDocs";
export const Route = createFileRoute("/enterprise-api-docs")({ head: ({match}) => pageHead(match.pathname), component: () => (<EnterpriseApiDocs />) });
